import $ from "jquery";

import Snackbar from "components/Snackbar";

const serverURL =
	window.location.protocol +
		"//" +
		window.location.hostname +
		window.location.port ===
	3000
		? ":3001"
		: "" + "/app";

class Server {
    static post(url, data, done, fail, forbidden) {
		let xhr = $.ajax({
			method: "POST",
			dataType: "json",
			xhrFields: {
				withCredentials: true
			},
			url: serverURL + url,
			data: data,
			statusCode: {
				403: function() {
                    if (forbidden != null) {
                        forbidden();
                    }
                    else
                    {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
				}
			}
		})
			.done((res, textStatus, jqXHR) => {
				if (done != null) done(res);
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				if (fail != null) fail(errorThrown);
				else {
					Server.handleError(errorThrown);
				}
			})
			.always(() => {});

		return xhr;
    }
    
    static submit(url, data, done, fail) {
        let xhr = $.ajax({
			method: "POST",
			xhrFields: {
				withCredentials: true
            },
            data: data,
			url: serverURL + url,
            processData: false,
            contentType: false,
            cache: false,
			statusCode: {
				403: function() {
					setTimeout(() => {
						window.location.reload();
					}, 2000);
				}
			}
		})
			.done((res, textStatus, jqXHR) => {
				if (done != null) done(res);
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				if (fail != null) fail(errorThrown);
				else {
					Server.handleError(errorThrown);
				}
			})
			.always(() => {});

		return xhr;
	}

	static handleError(errorThrown) {
        if (errorThrown != null &&
            typeof errorThrown == "string" && 
            errorThrown.trim().length > 0 &&
            errorThrown !== "abort" && 
            errorThrown.toUpperCase() !== "FORBIDDEN"
            ) 
            Snackbar.error(errorThrown);
	}
}

export default Server;
